import { render, staticRenderFns } from "./ks-investor.vue?vue&type=template&id=7dc490ca"
import script from "./ks-investor.vue?vue&type=script&lang=js"
export * from "./ks-investor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports